import PargodaModal from '../../../../PargodaModal';
import { jobsActions } from '../../../../../actions';
import {
    PargodaRoundButton,
    Typography,
    useAppDispatch,
    useTheme,
} from '../../../../../base';
import { ButtonsContainer } from './ProceedWithRecommendedModal.style';
import { useTranslation } from 'react-i18next';

interface Props {
    onClickProceed: () => void;
    isModalOpen: boolean;
}

const ProceedWithRecommendedModal = (props: Props) => {
    const { onClickProceed, isModalOpen } = props;
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { t } = useTranslation();
    const closeModal = (isModalOpen: boolean) => {
        dispatch(jobsActions.setProceedWithRecommendedModalOpen(isModalOpen));
    };
    return (
        <PargodaModal
            isModalOpen={isModalOpen}
            setIsModalOpen={(value: boolean) => {
                closeModal(value);
            }}
            modalTitle={t('saveJob.recommendationsDisclaimerTitle')}
        >
            <Typography variant="body2" pt={2} pb={2}>
                {t('saveJob.recommendationsDisclaimer')}
            </Typography>
            <ButtonsContainer>
                <PargodaRoundButton
                    textColor={theme.palette.grey[600]}
                    variant={'outlined'}
                    loadingPosition={'start'}
                    onClick={() => {
                        closeModal(false);
                    }}
                    startIcon={<></>}
                    loading={false}
                    sx={{
                        marginInlineEnd: theme.spacing(1.5),
                        height: '48px',
                        width: '214px',
                        fontWeight: 600,
                        fontSize: '16px',
                    }}
                >
                    {t('saveJob.recommendationsCancel')}
                </PargodaRoundButton>
                <PargodaRoundButton
                    onClick={onClickProceed}
                    type="submit"
                    variant="contained"
                    loading={false}
                    disabled={false}
                    sx={{
                        background: `linear-gradient(0deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        color: theme.palette.common.white,
                        width: '220px',
                        height: '48px',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        textTransform: 'none',
                    }}
                >
                    {t('saveJob.recommendationsProceed')}
                </PargodaRoundButton>
            </ButtonsContainer>
        </PargodaModal>
    );
};

export default ProceedWithRecommendedModal;
